export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_KEY;
export const BASE_URL = (process.env.REACT_APP_API_URL ||
                        "https://backend.golfbert.com");
